import { useEffect, useRef, useState } from "react";
import { trans } from "utils/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getDynamicDictionaryDictionaryApi } from "../api";

interface DynamicDictionaryPropsType {
  label?: string,
  hasBorder?: boolean,
  valueString?: string,

  resetForm?: boolean,
  required?: boolean,
  returnObj?: boolean,
  allowType?: boolean,
  value?: string,
  DescriptionKey?: string,
  mode?: string,
  DynamicObj?: any,
  name: string,
  Change?: (e) => void,
  onChange?: (e) => void,
}

export const DynamicDictionary = ({DescriptionKey, DynamicObj , label, hasBorder, value, valueString ,allowType=false,mode,returnObj=false ,resetForm,required , name="", Change ,onChange}: DynamicDictionaryPropsType) => {
  const [DynamicDictionary, setDynamicDictionarys] = useState<any>();
  const [valueName, setValueName] = useState<any>();
  const [flag, setFlag] = useState(false);
  const [show, setShow] = useState(false);
  const [validat , setValidat] = useState(false);
  const [rquird , setRquird] = useState(false);
  const [allowTyping , setAllowTyping] = useState(valueString&& allowType );
  const [count,setCount] = useState<number>(0);
  const inputRef = useRef<any>();
  const inputIdRef = useRef<any>();
  const inputTagRef = useRef<any>();
  const [disabled, setDisabled] = useState(mode == "view" ? true : false);
  const countRef = useRef<any>(0)
  let options_PostLevel_keys, options_PostLevel_values;



  async function getDynamicDictionaryListAsync(search?, id?) {
    try {
      let SystemKey  =  DynamicObj.initialSystemKey?DynamicObj.initialSystemKey : DynamicObj.typeNameEn
      if (id) {
        
        const res2 = await getDynamicDictionaryDictionaryApi(SystemKey);
        if(Object.values(res2?.[SystemKey])[0] && Object.values(res2?.[SystemKey])[0] != undefined){
          // setValeu( Object.values(res2)[0],  Object.keys(res2)[0])
          // setValueName( Object.values(res2)[0])
          setValeu( res2?.[SystemKey][id], id )
          setValueName( res2?.[SystemKey][id])
          if(!returnObj)
            onChange && onChange(res2?.[SystemKey][id])
          else
            onChange && onChange({Id:id , Name:res2?.[SystemKey][id]?.BindCodeInDescription ? res2?.[SystemKey][id]?.Description+" " + res2?.[SystemKey][id]?.Code  :res2?.[SystemKey][id]?.Description  })
        }else{
          
        }
       
      } else {
        const res = await getDynamicDictionaryDictionaryApi(SystemKey);
        setDynamicDictionarys(res?.[SystemKey])
        options_PostLevel_values = Object.values(res?.[SystemKey])
        options_PostLevel_keys = Object.keys(res?.[SystemKey])
        setShow(true)
      }
      setFlag(!flag)
    } catch (err: any) {
      
    }
  }


  const Auto = (e) => {
    setValidat(false)
    setRquird(false)
    setShow(true)
    Change && Change(true)
    getDynamicDictionaryListAsync(e.target.value, "")
    setFlag(!flag)
  }

  function userSelecter(){
    setValeu(options_PostLevel_values[countRef.current],options_PostLevel_keys[countRef.current])

  //  setValeu(options_PostLevel_values[countRef.current],Object.keys(options_PostLevel_keys)[countRef.current])
    setShow(false)
  }

  const kydown = (event) => {  
    if (event.key === 'Tab') {
      setShow(false)
    }

    if((event.key === "ArrowDown")){
      if(countRef.current < options_PostLevel_values.length-1){
        countRef.current = countRef.current + 1;
      }else{
        countRef.current = 0;
      }
    }
    
    if(event.key === "ArrowUp"){
      if(countRef.current > 0){
        countRef.current = countRef.current -1;
      }else{
        countRef.current = options_PostLevel_values.length-1;
      }
    }
    document.getElementById("DynamicDictionaryIndex"+countRef.current)?.scrollIntoView({block:'end',behavior:"smooth"})
    setCount(countRef.current)

    if(event.key === "Enter"){
      userSelecter()
    }

  }


  
  const CheckDynamicDictionary =async (e)=>{
    
    setTimeout(async() => {
      
      if(e.target.value.length == 0&& inputRef.current?.value?.length == 0 && e.target.value==""){
        inputIdRef.current.value = null
        inputTagRef.current.value = null
        if(required)
        setRquird(true)
    }else{
      setRquird(false)
      try{
        let systemkey = DynamicObj.initialSystemKey?DynamicObj.initialSystemKey :  DynamicObj.typeNameEn
        const res = await getDynamicDictionaryDictionaryApi(systemkey)
        if(Object.keys(res[systemkey]).length==0){
          setValidat(true)
        }
        if(Object.keys(res[systemkey]).length == 1){
          let val:any  = Object.values(res[systemkey])[0]
          setValeu(Object.values(res[systemkey])[0],  Object.keys(res[systemkey])[0] )
        }
      }catch(err:any){
        setValidat(true)
      }
    }
    }, 200);
    await delay(200)
    if(!document.activeElement?.className.includes("")){
      setShow(false)
   }
  }

  const delay = (duration) =>
  new Promise(resolve => setTimeout(resolve, duration));




  const setValeu = (value, id ,tag=null) => {
    if(inputIdRef != null && inputIdRef.current != null){

      setRquird(false)
      inputRef.current.value = value?.BindCodeInDescription ? value?.Description+" _ " + value?.Code +(tag?` (${tag})`:"")  :value?.Description +(tag?` (${tag})`:"")
      inputTagRef.current.value = tag ? +tag : +value.Tag
      
      inputIdRef.current.value = id
      setDynamicDictionarys(null)
      setTimeout(() => {
        inputRef.current.form.dispatchEvent(new Event('input', { bubbles: true }));

             }, 0);

      if(!returnObj)
      onChange && onChange(value?.BindCodeInDescription ? value?.Description+" " + value?.Code  :value?.Description)
    else
      onChange && onChange({Id:id , Name:value?.BindCodeInDescription ? value?.Description+" " + value?.Code  :value?.Description})

      setFlag(!flag)
    }
  }

  
  useEffect(() => {
    if (value) {
      getDynamicDictionaryListAsync(null, value)
    }else if(valueString&&allowType){
      onChange && onChange({Id:" " , Name:valueString})
    }
  }, [value ,resetForm]);

  
  useEffect(() => {
      setDisabled(mode == "view" ? true : false)
    
  }, [mode]);


  if (DynamicDictionary) options_PostLevel_values = Object.values(DynamicDictionary).map(item => {
    return item
  })
  if (DynamicDictionary) options_PostLevel_keys = Object.keys(DynamicDictionary).map(item => {
    return item
  })

  function clickToclose(e) {
    let input = document.querySelector("#browser" + name);
    if (e.target.id !== input?.id) {
      setShow(false);
    }
  }

  useEffect(() =>{
    if(show){
      document.addEventListener('keydown', kydown,true);
      document.body.addEventListener("click", clickToclose)
    } 
    return () => { document.removeEventListener("keydown", kydown,true);document.body.removeEventListener('click', clickToclose) }

  },[show ,options_PostLevel_values])



  return (
    <>
      <div className="text-box">
        {label && 
      <OverlayTrigger
             key={label}
             placement="top"
             delay={{"show" : 600 , "hide":0}}
             overlay={
                <Tooltip className="tooltip " id={`button-tooltip-${"reserve"}`}>
                {trans(label)}
                </Tooltip>
                }>
                 <div className="d-flex align-items-center" style={{height:'22px'}}>
                   <label className="text-box__label showDots"  style={{maxWidth:'90%'}}>{trans(`${label}`)}{DynamicDictionary?.[0]?.Tag ? (inputTagRef.current.value?  `  (${inputTagRef.current.value})`:" ") : ""}</label>
                   {required && <span className='text-box__required-sign-for-label text-danger me-1'>*</span>}
                  {(allowType&&mode!="view")&&
                  <>
                  {
                    allowTyping ?
                    <FontAwesomeIcon onClick={()=>{setAllowTyping(false)}} style={{marginRight:"5px"}} icon={["fas", "magnifying-glass"]} className="text-primary pr-2"/>
                    :
                    <FontAwesomeIcon onClick={()=>{setAllowTyping(true)}} style={{marginRight:"5px"}} icon={["fas", "magnifying-glass-minus"]} className="text-danger  pr-2"/>

                  }
                  </>
                  }
                 </div>
          </OverlayTrigger> 
        }


        <input required={required} defaultValue={value ? value:valueString}   name={name+"value"} className="d-none" ref={inputIdRef} />
        <input required={required}    name={name} className="d-none" ref={inputTagRef} />
        
        {(!allowTyping||!allowType)?
        <>
        <input required={required} autoFocus={(!allowTyping&&valueName)} defaultValue={valueName}  onBlur={CheckDynamicDictionary} autoComplete="off" onMouseDown={(e) => {e.stopPropagation(); Auto(e) }} onFocus={() => {getDynamicDictionaryListAsync(!allowTyping ? valueName:null); setShow(true) }} ref={inputRef} list="DynamicDictionaryList" name={DescriptionKey?DescriptionKey:"browser"} className={"text-box__box form-control" + " browser"+name} type={'text'} id={"browser"+name} onChange={Auto} disabled={disabled} />
        {
          show &&
          <div className={`text-box__sub-menu mt-1 glassBox border border-1`} tabIndex={-1} >    
            {options_PostLevel_values && options_PostLevel_values.map((item, index) => {
              return <div id={"DynamicDictionaryIndex"+index}  className={`${count == index ?"text-box__sub-menu-option-active" : "text-box__sub-menu-option"}`} onClick={(e) => { setValeu(item,options_PostLevel_keys[index],item.Tag) }} key={options_PostLevel_keys[index]} >{item?.BindCodeInDescription ? item?.Description+" _ " + item?.Code  :item?.Description}{item.Tag ?` (${item.Tag})`:"" }</div>
            })}
          </div>
        }
        </>
        :
        <input required={required} defaultValue={valueString}  onBlur={(e)=>{onChange&&onChange( {Id:" " , Name:e.target.value});inputIdRef.current.value = e.target.value }} onChange={(e)=>{setValueName(e.target.value)}}  ref={inputRef}  name="browser" className={"text-box__box form-control" + " browser"+name} type={'text'} id={"browser"+name} disabled={disabled} />

        }
        <div className="text-box__msg-wrapper">
         {required && <span className={`${validat ? "show-msg" : "hide-msg"} text-box__required-msg text-danger`}>{trans("Msg_Validation_ValueIsIncorrect")}</span>}
         {required && <span className={`${rquird ? "show-msg" : "hide-msg"} text-box__required-msg text-danger`}>{trans("Msg_Validation_ValueIsRequired", [""])}</span>}
        </div>    
 
      </div>
    </>
  )
}